import { Col, Row } from 'antd';
import * as moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomDivider from '../../../v2-components/Antd/Divider';
import CustomInput from '../../../v2-components/Antd/Input';
import CustomModal from '../../../v2-components/Antd/Modal';
import CustomSelect from '../../../v2-components/Antd/Select';
import CustomTextArea from '../../../v2-components/Antd/TextArea';
import Loading from '../../../v2-components/Loading';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import { GLOBAL_DICTIONARY } from './constants/global-dictionary.constant';
import { ANSWERS } from './constants/select-answers.constant';
import { STATUS_ADAPTER } from './constants/status-adapter.constant';
import { STATUS_DICTIONARY } from './constants/status-dictionary.constant';
import { TEXT_STATUS } from './constants/text-status.constant';
import { TYPE_ADAPTER } from './constants/type-adapter.constant';
import { claimResponse } from './handle/claim-response.handle';
import { defaultValueSelect } from './handle/default-value-select.handle';
import { defaultValueTextArea } from './handle/default-value-text-area.handle';
import { disableSelect } from './handle/disabled-select.handle';
import { disableButton } from './handle/disabled-send-button.handle';
import { hideComponent } from './handle/hide-component.handle';
import { unixAdapter } from './handle/unix-adapter.handle';
import { Service } from './service';
import './style.scss';


export default function ClaimsDetailAdminPage() {
	const { t } = useTranslation('global');
	const { id } = useParams();
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [selectValue, setSelectValue] = useState();
	const [textAreaValue, setTextAreaValue] = useState();
	const [openModal, setOpenModal] = useState(false);
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [renderData, setRenderData] = useState(false);

	const { token } = GetLocalStorageValue('userInfo');
	console.log('id',id)

	useEffect(() => {
		new Service().getClaimById(id).then((response) => {
			console.log('response', response);
			setData(response[0]);
			setIsLoading(false);
		});
	}, [id, renderData]);

	const dateNow = moment().format('DD/MM/YYYY');

	const handleSelectChange = (value) => {
		setSelectValue(value);
	};

	const handleTextArea = (e) => {
		setTextAreaValue(e.target.value);
	};

	const handleResendEmail = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.resendEmail({ ...data, request: true })
			.then((response) => {
				setOpenLoadingModal(false);
				setIsLoadingModal(false);
				return CustomNotification({
					type: 'success',
					message: 'Exito',
					description: 'Correo enviado satisfactoriamente',
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleCloseClaim = () => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		setOpenModal(false);
		Promise.all([
			new Service().updateClaim(data._id, { status: STATUS_DICTIONARY.close, response: claimResponse(selectValue, textAreaValue) }, token),
			new Service().sendEmailClosed({ ...data, response: claimResponse(selectValue, textAreaValue) }),
		])
			.then(([updateClaimResponse, sendEmailClosedResponse]) => {
				setRenderData(true);
				setOpenLoadingModal(false);
				setIsLoadingModal(false);
				return CustomNotification({
					type: 'success',
					message: 'Exito',
					description: 'Solicitud cerrada exitosamente',
				});
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const renderTextArea = (selectValue) => {
		if (selectValue === GLOBAL_DICTIONARY.other) {
			return (
				<Row style={{ display: hideComponent(data?.status) }}>
					<span>Comentarios</span>
					<CustomTextArea placeholder={'Mensaje personalizado'} onChange={handleTextArea} />
				</Row>
			);
		}
	};

	if (isLoading) {
		return <Loading />;
	}
	return (
		<div className="ph-admin-claims-detail-page-container">
			<h2>Solicitud n° {data?.claim_id}</h2>
			<Link to={`/v2/admin-claims/list?status=open&page=1`}>Volver a reclamos y sugerencias</Link>

			<Row justify="space-evenly" className="own-claim-detail">
				<Col span={11}>
					<CustomCard>
						<h2>Tipo de solicitud: {TYPE_ADAPTER[data?.type]}</h2>
						<h3>Datos de la solicitud</h3>
						<p>Farmacia: {data?.pharmacy}</p>
						<p>N° orden asociada: {data?.trx_id || '--'} </p>
						<p>Fecha: {unixAdapter(data?.created_at)}</p>
						<h3>Datos del cliente</h3>
						<p>Nombre: {data?.first_name}</p>
						<p>Apellido: {data?.last_name}</p>
						<p>
							{t('tracking.personalId')}: {data?.rut}
						</p>
						<p>Teléfono: {data?.phone}</p>
						<p>Correo electrónico: {data?.email}</p>
						<h3>Mensaje</h3>
						<p>{data?.message}</p>
						<Row justify="center">
							<Col>
								<CustomButton onClick={handleResendEmail}>REENVIAR CORREO</CustomButton>
							</Col>
						</Row>
					</CustomCard>
				</Col>
				<Col span={11}>
					<CustomCard>
						<h2>Estado de la solicitud</h2>
						<h3>{STATUS_ADAPTER[data?.status]}</h3>
						<p>{TEXT_STATUS[data?.status]}</p>
						<CustomInput value={dateNow} disabled />
						<div style={{ marginTop: '10px' }}>
							<span>Respuesta</span>
							<CustomSelect
								style={{ width: '100%', marginBottom: '20px' }}
								disabled={disableSelect(data?.status)}
								onChange={handleSelectChange}
								options={ANSWERS[data?.type?.split('-')[0]]}
								defaultValue={defaultValueSelect(data?.status, data?.response)}
							/>
							{renderTextArea(selectValue)}
							{defaultValueTextArea(data?.status, data?.response)}
							<Row justify="center" style={{ marginTop: '20px' }}>
								<Col>
									<CustomButton
										style={{ display: hideComponent(data?.status) }}
										disabled={disableButton(selectValue)}
										onClick={() => setOpenModal(true)}
									>
										ENVIAR
									</CustomButton>
								</Col>
							</Row>
							<CustomModal onCancel={() => setOpenModal(false)} footer={null} open={openModal}>
								<h3>Cerrar solicitud</h3>
								<CustomDivider />
								<p>¿Estas seguro que deseas cerrar la siguiente solicitud?</p>

								<ul>
									<li>
										{TYPE_ADAPTER[data?.type]} n° {data?.claim_id}
									</li>
									<li>Solicitud iniciada el {unixAdapter(data?.created_at)}</li>
								</ul>

								<CustomDivider />
								<div>
									<CustomButton onClick={() => setOpenModal(false)}>Cancelar</CustomButton>
									<CustomButton onClick={handleCloseClaim}>Confirmar</CustomButton>
								</div>
							</CustomModal>
						</div>
					</CustomCard>
					<LoadingModal loading={isLoadingModal} visible={openLoadingModal} />
				</Col>
			</Row>
		</div>
	);
}
